import type { FlexibleUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";
import type { PageContent } from "#/_packages/umbrella/types";

export default function FlexibleUmbPage({
	content,
}: PageContent<FlexibleUmbPageContentResponseModel>) {
	return (
		<div>
			<BlockGrid
				prioritizeLeadingMedia
				noVerticalSpacing={content.properties?.noVerticalSpacing ?? false}
				contentArea={content.properties?.blockGrid}
			/>
		</div>
	);
}
